/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PermissionDto } from '../models/permission-dto';


/**
 * Fonctions de gestion des permissions
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation permissionGetList
   */
  static readonly PermissionGetListPath = '/api/permissions/list';

  /**
   * Renvoie la liste des permissions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PermissionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PermissionDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des permissions.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionGetList(params?: {
  }): Observable<Array<PermissionDto>> {

    return this.permissionGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PermissionDto>>) => r.body as Array<PermissionDto>)
    );
  }

  /**
   * Path part for operation permissionLoadList
   */
  static readonly PermissionLoadListPath = '/api/permissions/load-list';

  /**
   * Renvoie la liste des permissions (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des permissions (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.permissionLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation permissionGet
   */
  static readonly PermissionGetPath = '/api/permissions/{id}';

  /**
   * Renvoie la permission spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionGet$Response(params: {

    /**
     * Identifiant de la permission
     */
    id: number;
  }): Observable<StrictHttpResponse<PermissionDto>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PermissionDto>;
      })
    );
  }

  /**
   * Renvoie la permission spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionGet(params: {

    /**
     * Identifiant de la permission
     */
    id: number;
  }): Observable<PermissionDto> {

    return this.permissionGet$Response(params).pipe(
      map((r: StrictHttpResponse<PermissionDto>) => r.body as PermissionDto)
    );
  }

  /**
   * Path part for operation permissionPut
   */
  static readonly PermissionPutPath = '/api/permissions/{id}';

  /**
   * Met à jour la permission spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionPut$Response(params: {

    /**
     * Identifiant de la permission à mettre à jour
     */
    id: number;

    /**
     * Permission
     */
    body: PermissionDto
  }): Observable<StrictHttpResponse<PermissionDto>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PermissionDto>;
      })
    );
  }

  /**
   * Met à jour la permission spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionPut(params: {

    /**
     * Identifiant de la permission à mettre à jour
     */
    id: number;

    /**
     * Permission
     */
    body: PermissionDto
  }): Observable<PermissionDto> {

    return this.permissionPut$Response(params).pipe(
      map((r: StrictHttpResponse<PermissionDto>) => r.body as PermissionDto)
    );
  }

  /**
   * Path part for operation permissionDelete
   */
  static readonly PermissionDeletePath = '/api/permissions/{id}';

  /**
   * Supprime la permission spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionDelete$Response(params: {

    /**
     * Identifiant de la permission à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la permission spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionDelete(params: {

    /**
     * Identifiant de la permission à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.permissionDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation permissionPost
   */
  static readonly PermissionPostPath = '/api/permissions';

  /**
   * Crée la permission spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionPost$Response(params: {

    /**
     * Permission
     */
    body: PermissionDto
  }): Observable<StrictHttpResponse<PermissionDto>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PermissionDto>;
      })
    );
  }

  /**
   * Crée la permission spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionPost(params: {

    /**
     * Permission
     */
    body: PermissionDto
  }): Observable<PermissionDto> {

    return this.permissionPost$Response(params).pipe(
      map((r: StrictHttpResponse<PermissionDto>) => r.body as PermissionDto)
    );
  }

}
